<template>
  <div class="relative">
    <button 
      @click="isOpen = !isOpen"
      class="flex items-center space-x-1 p-2 text-gray-600 hover:text-gray-900 transition-colors"
    >
      <GlobeAltIcon class="h-5 w-5" />
      <span class="text-sm font-medium uppercase">{{ currentLocale }}</span>
      <ChevronDownIcon class="h-4 w-4" :class="{ 'rotate-180': isOpen }" />
    </button>
    
    <div v-if="isOpen" class="absolute right-0 mt-2 w-40 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-50">
      <div class="py-1">
        <button
          v-for="lang in availableLanguages"
          :key="lang.code"
          @click="changeLanguage(lang.code)"
          class="w-full text-left px-4 py-2 text-sm hover:bg-gray-100 flex items-center space-x-2"
          :class="{ 'bg-orange-50 text-orange-600': currentLocale === lang.code }"
        >
          <span class="text-lg">{{ lang.flag }}</span>
          <span>{{ lang.name }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { GlobeAltIcon, ChevronDownIcon } from '@heroicons/vue/24/outline'

const { locale } = useI18n()

const isOpen = ref(false)

const currentLocale = computed(() => locale.value)

const availableLanguages = [
  { code: 'pt-BR', name: 'Português', flag: '🇧🇷' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Español', flag: '🇪🇸' }
]

const changeLanguage = (code: string) => {
  locale.value = code
  localStorage.setItem('locale', code)
  isOpen.value = false
}
</script>
